import React from 'react';
import Stack from '@mui/material/Stack';
import {ContentBlockHeader} from '@growcloud-io/dc/components/surface/ContentBlockHeader';
import {newColumnStack} from "@growcloud-io/gcio-commons/common/utils/UiUtils";
import {FeaturesTable} from "@growcloud-io/gcio-commons/common/components/FeaturesTable";
import {getFeaturesData} from "./data/FrontPageData";

export const FeaturesPage = ({}) => {
  const featuresData = getFeaturesData();
  return (
    <Stack direction={'column'} sx={newColumnStack()}>
      <ContentBlockHeader
        PageTitle={'FEATURES'}
        SubHeader={''}
        Alignment="left"
      />
      <FeaturesTable
        featuresData={featuresData}
      />
    </Stack>
  );
}
